import { Component, Input } from "@angular/core";

@Component({
  standalone: false,
  selector: 'app-custom-accordion',
  template: `
  <div ngbAccordion [ngClass]="{ 'accordion-hover': !disableAccordian }">
    <div ngbAccordionItem [disabled]="disableAccordian" [collapsed]="true" [ngClass]="{ active: isActive }">
      <div ngbAccordionHeader class="accordion-button custom-header justify-content-between no-caret m-0 p-0">
        <button ngbAccordionButton (click)="isActive = !isActive">
          <div class="container m-0 p-0">
            <div class="row">
              <div class="col-md d-flex align-items-center ">
                <h3 class="mb-0">{{ title }}</h3>
              </div>
              <div class="col-md d-flex align-items-center text-left">
                <p class="mb-0">
                  <span *ngIf="isError"><i class="material-icons-round text-danger">warning</i></span>
                  <span class="text-base ms-1" [innerHTML]="expanderText"></span>
                </p>
              </div>
            </div>
          </div>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <ng-content></ng-content>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  `
})
export class CustomAccordionComponent {

  @Input()
  title: string;

  @Input()
  expanderText: string;

  @Input()
  isActive = false;

  @Input()
  isError = false;

  @Input()
  disableAccordian = false;

  public isCustomHeaderAccordionActive = false;

}
